import { ChangeEvent, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import * as Yup from "yup";

import {
  SIP_TYPE_OPTIONS_EXISTING,
  SIP_TYPE_OPTIONS_NEW,
  getFolioOptions,
} from "..";

import { useAppSelector } from "../../../../../store/hooks";
import {
  addItemsToCart,
  getAmcMasters,
  getMinimumAmount,
  getSipCategory,
  getSipDayList,
  getSipFrequency,
  getSipSchemes,
  swpOptions,
  updateCartItem,
} from "../../../../../store/actions";
import {
  CalcSIPEnddt,
  checkAotmStatus,
} from "../../../../../store/actions/cart";
import {
  Options,
  FrequencyOptions,
  SipSchemeOptions,
  NEWP,
  NEW,
  EXISTINGP,
  EXISTING,
  PAYMENT_MODE,
  InvestorFundDetails,
  Option,
} from "../../../../../store/types";

import {
  convertDate,
  convertDateToIndian,
  convertToInr,
  getSchemeDetails,
  getSipSchemesFromFolios as getSchemesFromFolio,
  getSelectedCartItem,
  getSipSchemesFromFolios as getSipSchemesFromFolio,
  handleError,
} from "../../../../../utils/cart";
import { getFrequencyName } from "../../../transactions/tranUtils";
import { epochToDate } from "../../../../../utils/common";
import { differenceInMonths } from "date-fns";
import moment from "moment";

interface Location {
  cartId: string;
  cartItemId: string;
  amc: string;
}

interface OnChange extends ChangeEvent<{ name?: string; value: any }> {}

type HandleChange = (
  values: Values,
  setValues: React.Dispatch<React.SetStateAction<Values>>
) => (event: OnChange) => any;

type HandleTypeChange = (
  values: Values,
  setValues: React.Dispatch<React.SetStateAction<Values>>
) => (event: any) => any;

type HandleCheckBoxChange = (
  values: Values,
  setValues: React.Dispatch<React.SetStateAction<Values>>
) => (event: ChangeEvent<HTMLInputElement>, checked: boolean) => any;

const FIELD_NAMES: Array<keyof Values> = [
  "fund",
  "sipType",
  "folio",
  "purchaseType",
  "category",
  "scheme",
  "frequency",
  "noOfInstallments",
  "sipDay",
  "startDate",
  "endDate",
  "perpetual",
  "installmentAmount",
  "amount",
];

export default function useSip() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation<Location>();

  const { pathname } = location;

  const isEdit = pathname.includes("/edit");
  const isSipExisting = pathname.includes("/sip-existing");

  //@ts-ignore
  const cartItems: CartItems<"SIP"> = useAppSelector(
    ({ cartReducer }) => cartReducer.cartItems
  );
  const { fundDetails } = useAppSelector(({ cartReducer }) => cartReducer);

  const { payload } = getSelectedCartItem<"ISIP">(cartItems, location.state);
  const folios = getFolioOptions(fundDetails, payload.fund);

  const [modeOptions, setModeOptions] = useState<Options>([]);
  const [amcMasters, setAmcMasters] = useState<Options>([]);
  const [categories, setCategories] = useState<Options>([]);
  const [sipDays, setSipDays] = useState<Options>([]);

  const [initialValues, setInitialValues] = useState<Values>({
    fund: payload.fund,
    endDate: "",
    frequency: "",
    installmentAmount: "",
    noOfInstallments: "",
    scheme: "",
    sipDay: "",
    sipType: payload.newPurchaseSipType
      ? "NEWP"
      : payload.transactionType === "ISIP"
      ? "EXISTING"
      : payload.transactionType === "SIN"
      ? "EXISTINGP"
      : "NEW",
    startDate: "",
    amount: "",
    category: "",
    folio: "",
    perpetual: false,
    modeOfRegistration: payload.modeOfRegistration,
  });

  const [schemes, setSchemes] = useState<SipSchemeOptions>([]);
  const [frequencies, setFrequencies] = useState<FrequencyOptions>([]);

  function goToCart() {
    history.replace("/cart/investor-cart", {
      pan: payload.pan,
    });
  }
  const onSubmit = async (values: Values) => {
    const {
      fund,
      endDate,
      category,
      frequency,
      installmentAmount,
      amount,
      noOfInstallments,
      scheme,
      sipDay,
      startDate,
    } = values;

    // @ts-ignore
    const schemeDetails = schemes.find(({ value }) => value === scheme)!;
    const {
      option,
      plan,
      scheme: selectedScheme,
      label,
    } = getSchemeDetails(schemeDetails);

    const requestBody = {
      ...payload,
      fund,
      pan: payload.pan,
      option,
      plan,
      sipDay,
      category,
      noOfInstallments,
      installmentAmount,
      perpetual: values.perpetual,
      sipEndDate: convertDate(endDate),
      sipFrequency: getFrequencyName(frequency),
      sipStartDate: convertDate(startDate),
      scheme: selectedScheme,
      amount: Number(amount) || 0,
      schemeName: label,
      folio: values.folio || 0,
      combo: values.combo,
    };

    if (isEdit) {
      await updateTransaction(requestBody);
      return;
    }
    await addToCart(requestBody);
  };

  const updateTransaction = async function (requestBody: any) {
    try {
      const response = await updateCartItem({
        ...requestBody,
        cartId: location.state.cartId,
        cartItemId: location.state.cartItemId,
      })(dispatch);
      if (response) {
        goToCart();
      }
    } catch (error) {
      handleError(error);
    }
  };

  const addToCart = async function (requestBody: any) {
    try {
      const response = await addItemsToCart(requestBody)(dispatch);
      if (response) {
        goToCart();
      }
    } catch (error) {
      handleError(error);
    }
  };

  const resetLaterFields = function (
    values: Values,
    key: keyof Values,
    fieldValues: Partial<Values>
  ): Values {
    const index = FIELD_NAMES.findIndex((fieldName) => fieldName === key);
    const updatedValues = FIELD_NAMES.slice(index).reduce<Partial<Values>>(
      (acc, curr) => {
        return { ...acc, [curr]: "" };
      },
      {}
    );

    return { ...values, ...updatedValues, ...fieldValues };
  };
  const fetchModeOfRegistrationOptions = async function (fund: string) {
    const requestBody = {
      opt: PAYMENT_MODE,
      astscheme: payload.pan,
      Fund: fund,
      acno: payload.folio || "0",
    };
    const response = await swpOptions(requestBody)(dispatch);
    if (!response) return;
    if (!response?.Dtinformation?.length) return;
    const isPanBasedAotm = await checkAotmStatus(fund)(dispatch);
    const paymodes = response.Dtinformation.map(
      ({ Pay_Mode, Pay_Mode_Val }: any) => ({
        label: Pay_Mode,
        value: Pay_Mode_Val,
      })
    )
      .filter((option: any) =>
        isPanBasedAotm || Boolean(requestBody.acno)
          ? true
          : option.value !== "AOTM"
      )
      .filter((i: Option) => {
        if (fund !== "129") return true;
        return i.value !== "AOTM";
      });

    setModeOptions(paymodes);
  };

  const handleTypeChange: HandleChange = function (values, setValues) {
    return function (e) {
      setValues(
        resetLaterFields(values, "sipType", {
          sipType: e.target.value,
        })
      );
    };
  };

  const handleFolioChange: HandleChange = function (values, setValues) {
    return function (e) {
      const folio = e.target.value;
      if (payload.modeOfRegistration !== "AOTM") {
        setValues(
          resetLaterFields(values, "folio", {
            folio: folio,
            purchaseType: EXISTING,
          })
        );
        setSchemes(getSchemesFromFolio(payload.fund, folio, fundDetails));
        return;
      }
      if (Number(payload.folio) !== Number(folio)) {
        alert("Different folios are not allowed in cart for AOTM transactions");
        return;
      }
      setValues(
        resetLaterFields(values, "folio", {
          folio: folio,
          purchaseType: EXISTING,
        })
      );
      setSchemes(getSchemesFromFolio(payload.fund, folio, fundDetails));
      return;
    };
  };

  const handlePurchaseTypeChange: HandleTypeChange = function (
    values,
    setValues
  ) {
    return function (e) {
      if (!e) return;
      setValues(
        resetLaterFields(values, "purchaseType", {
          purchaseType: e,
        })
      );
      if (e === EXISTING) {
        setSchemes(
          getSchemesFromFolio(payload.fund, values.folio, fundDetails)
        );
        return;
      }
    };
  };

  const handleCategoryChange: HandleChange = function (values, setValues) {
    return async function (e) {
      const category = e.target.value;
      const response = await getSipSchemes({
        category,
        acno: "0",
        fundCode: payload.fund,
      })(dispatch);
      setSchemes(response);
      setValues(
        resetLaterFields(values, "category", {
          category,
        })
      );
    };
  };

  const handleSchemeChange: HandleChange = function (values, setValues) {
    return async function (e) {
      try {
        const scheme = e.target.value;
        // @ts-ignore
        const selectedScheme = schemes.find(({ value }) => scheme === value);

        const { newPurchaseMinAmount = 100, multiples = 1 } = selectedScheme;
        const response = await getSipFrequency(
          payload.fund,
          selectedScheme.scheme,
          selectedScheme.plan
        )(dispatch);
        setFrequencies(response);
        setValues(
          resetLaterFields(values, "scheme", {
            scheme,
            newPurchaseMinAmount,
            multiples,
          })
        );
        return;
      } catch (error) {
        handleError(error);
      }
    };
  };

  const handleFrequencyChange: HandleChange = function (values, setValues) {
    return async function (e) {
      try {
        const frequency = e.target.value;
        const response = await getSipDayList(payload.fund, frequency)(dispatch);
        const selectedFrequency = frequencies.find(
          ({ value }) => value === frequency
        );
        const { minimumInstallments } = selectedFrequency;
        const selectedScheme = schemes.find(
          ({ value }) => value === values.scheme
        );
        const requestBody = {
          Fund: values.fund,
          TrType: "SIP",
          Frequency: frequency,
          Scheme: getSchemeDetails(selectedScheme).scheme,
        };
        const minResponse = await getMinimumAmount(requestBody)(dispatch);
        const sipMinAmount = minResponse.DtData[0].minamt;

        setSipDays(response);
        setValues(
          resetLaterFields(values, "frequency", {
            frequency,
            sipMinAmount,
            minimumInstallments,
            newPurchaseMinAmount: values.newPurchaseMinAmount,
          })
        );
      } catch (error) {
        handleError(error);
      }
    };
  };

  const handleSipDayChange: HandleChange = function (values, setValues) {
    return async function (e) {
      try {
        const sipDay = e.target.value;
        // @ts-ignore
        const schemeDetails = schemes.find(
          ({ value }: any) => value === values.scheme
        )!;
        const { scheme: selectedScheme } = getSchemeDetails(schemeDetails);

        const requestBody = {
          fund: payload.fund,
          sch: selectedScheme,
          StartDate: sipDay,
          Installments: values.noOfInstallments,
          Frequency: values.frequency,
          trtype: "SIP",
          modeOfRegistration: values.modeOfRegistration,
        };

        const response = await CalcSIPEnddt(requestBody)(dispatch);
        const {
          DtData: [dates],
        } = response;
        const { SIP_StartDate, SIP_EndDate } = dates;

        const formattedEndDate = new Date(convertDate(SIP_EndDate));
        const isIsip = values.modeOfRegistration === "ISIP";
        const perpetualEndDate = isIsip
          ? getPerpetualSipEndDate(SIP_StartDate, "ISIP")
          : getPerpetualSipEndDate(SIP_StartDate);
        const isValidEndDate =
          formattedEndDate.getTime() <= perpetualEndDate.getTime();

        if (!isValidEndDate) {
          setValues(
            resetLaterFields(values, "noOfInstallments", {
              sipDay: "",
              startDate: "",
              endDate: "",
              noOfInstallments: "",
            })
          );
          throw new Error(
            `SIP End date cannot exceed  ${convertDateToIndian(
              perpetualEndDate
            )}`
          );
        }

        setValues(
          resetLaterFields(values, "startDate", {
            sipDay: sipDay,
            startDate: SIP_StartDate,
            endDate: SIP_EndDate,
          })
        );
      } catch (error) {
        handleError(error);
      }
    };
  };
  const handleInstallmentChange: HandleChange = function (values, setValues) {
    return async function (e) {
      try {
        const noOfInstallments = e.target.value;
        setValues(
          resetLaterFields(values, "noOfInstallments", {
            noOfInstallments,
          })
        );
      } catch (error) {
        handleError(error);
      }
    };
  };

  const handlePerpetual: HandleCheckBoxChange = function (values, setValues) {
    return function (e, checked) {
      const isChecked = checked;
      const { frequency } = values;
      if (!isChecked) {
        const updatedFields = resetLaterFields(values, "frequency", {
          perpetual: false,
        });
        setValues(updatedFields);
        return;
      }

      if (values.modeOfRegistration === "ISIP") {
        const noOfInstallments = calculateNoOfInstallments(
          frequency,
          values.startDate,
          "ISIP"
        );
        const endDate = getPerpetualSipEndDate(values.startDate, "ISIP");
        const updatedFields = resetLaterFields(values, "endDate", {
          perpetual: true,
          noOfInstallments,
          endDate: moment(endDate).format("DD/MM/YYYY"),
        });
        setValues(updatedFields);
        return;
      }

      const noOfInstallments = calculateNoOfInstallments(
        frequency,
        values.startDate
      );
      const endDate = getPerpetualSipEndDate(values.startDate);
      const updatedFields = resetLaterFields(values, "endDate", {
        perpetual: true,
        noOfInstallments,
        endDate: moment(endDate).format("DD/MM/YYYY"),
      });
      setValues(updatedFields);
    };
  };

  const getPerpetualSipEndDate = (startDate: string, mode?: "ISIP") => {
    const [startDay] = moment(startDate, "DD/MM/YYYY")
      .format("DD/MM/YYYY")
      .split("/");

    if (mode === "ISIP") {
      const endDate = new Date(2099, 11, Number(startDay));
      return endDate;
    }

    const date = new Date();
    date.setDate(Number(startDay));
    date.setMonth(date.getMonth() - 1);
    date.setFullYear(date.getFullYear() + 40);
    return date;
  };

  const calculateNoOfInstallments = (
    frequency: any,
    startDate: string,
    mode?: "ISIP"
  ): string => {
    const ONE_MINUTE = 1000 * 60;
    const ONE_HOUR = ONE_MINUTE * 60;
    const ONE_DAY = ONE_HOUR * 24;

    const newStartDate = new Date(convertDate(startDate));
    const endDate = getPerpetualSipEndDate(startDate, mode);

    const noOfMonths = differenceInMonths(endDate, newStartDate);

    const frequencyMap: any = {
      DAILY: Math.floor((endDate.getTime() - newStartDate.getTime()) / ONE_DAY),
      WEEKLY: Math.floor(
        (endDate.getTime() - newStartDate.getTime()) / ONE_DAY / 7
      ),
      FORTNIGHTLY: Math.floor(noOfMonths * 2),
      MONTHLY: Math.floor(noOfMonths),
      QUARTERLY: Math.floor(noOfMonths / 3),
      HALFYEARLY: Math.floor(noOfMonths / 6),
      YEARLY: Math.floor(noOfMonths / 12),
    };

    if (frequencyMap[frequency.toUpperCase()]) {
      return frequencyMap[frequency.toUpperCase()];
    }
    return "";
  };

  useEffect(() => {
    (async function () {
      try {
        const amcOptions = await getAmcMasters()(dispatch);
        const categoryOptions = await getSipCategory(payload.fund)(dispatch);
        await fetchModeOfRegistrationOptions(payload.fund);
        setAmcMasters(amcOptions);
        setCategories(categoryOptions);
        if (!isEdit) {
          return;
        }

        const {
          amount,
          category,
          folio,
          scheme,
          plan,
          option,
          sipFrequency,
          noOfInstallments,
          sipDay,
          sipStartDate,
          sipEndDate,
          installmentAmount,
          fund,
          perpetual,
        } = payload;
        //Convert the dates to epoch as soon as possible
        const sipStartDateEpoch = new Date(sipStartDate).getTime();
        const sipEndDateEpoch = new Date(sipEndDate).getTime();

        const sipDaysList = await getSipDayList(
          fund,
          getFrequencyName(sipFrequency)
        )(dispatch);
        setSipDays(sipDaysList);
        if (folio && category) {
          // get scheme list from API if folio and category are present
          const schemeOptions = await getSipSchemes({
            acno: folio,
            category,
            fundCode: payload.fund,
          })(dispatch);
          setSchemes(schemeOptions);

          const selectedScheme = schemeOptions.find((schemeDetails) =>
            [
              schemeDetails.scheme === scheme,
              schemeDetails.plan === plan,
              schemeDetails.option === option,
            ].every(Boolean)
          );
          const { newPurchaseMinAmount = 100, multiples = 1 } = selectedScheme;
          const frequencyList = await getSipFrequency(
            fund,
            selectedScheme.scheme,
            selectedScheme.plan
          )(dispatch);
          setFrequencies(frequencyList);
          const requestBody = {
            Fund: payload.fund,
            TrType: "SIP",
            Frequency: sipFrequency,
            Scheme: selectedScheme.scheme,
          };
          const minResponse = await getMinimumAmount(requestBody)(dispatch);
          const sipMinAmount = minResponse.DtData[0].minamt;
          setInitialValues((prev) => ({
            ...prev,
            endDate: epochToDate(sipEndDateEpoch, "dd/mm/yyyy"),
            frequency: getFrequencyName(sipFrequency),
            installmentAmount,
            noOfInstallments,
            scheme: selectedScheme.value,
            sipDay,
            fund,
            amount,
            category,
            folio,
            minimumInstallments: frequencyList.find(
              ({ value }) => value === getFrequencyName(sipFrequency)
            )?.minimumInstallments,
            newPurchaseMinAmount,
            sipMinAmount,
            multiples,
            startDate: epochToDate(sipStartDateEpoch, "dd/mm/yyyy"),
            purchaseType: NEW,
            combo: payload.combo,
            perpetual: perpetual,
          }));
          return;
        }
        if (folio) {
          // If category is not available it means the user have selected from the list of new schemes
          const schemeOptions = getSipSchemesFromFolio(
            fund,
            folio,
            fundDetails
          );
          setSchemes(schemeOptions);
          const selectedScheme = schemeOptions.find((schemeDetails) =>
            [
              schemeDetails.scheme === scheme,
              schemeDetails.plan === plan,
              schemeDetails.option === option,
            ].every(Boolean)
          );
          const { value } = selectedScheme;
          const requestBody = {
            Fund: payload.fund,
            TrType: "SIP",
            Frequency: sipFrequency,
            Scheme: selectedScheme.scheme,
          };
          const minResponse = await getMinimumAmount(requestBody)(dispatch);
          const sipMinAmount = minResponse.DtData[0].minamt;
          const minimumInstallments = frequencies.find(
            ({ value }) => value === getFrequencyName(sipFrequency)
          )?.minimumInstallments;
          const { newPurchaseMinAmount, multiples = 1 } = selectedScheme;
          setInitialValues((prev) => ({
            ...prev,
            endDate: epochToDate(sipEndDateEpoch, "dd/mm/yyyy"),
            frequency: getFrequencyName(sipFrequency),
            installmentAmount,
            noOfInstallments,
            scheme: value,
            sipDay,
            fund,
            amount,
            folio,
            category: "",
            minimumInstallments,
            newPurchaseMinAmount,
            sipMinAmount,
            multiples,
            purchaseType: EXISTING,
            startDate: epochToDate(sipStartDateEpoch, "dd/mm/yyyy"),
            combo: payload.combo,
            perpetual: perpetual,
          }));
          return;
        }

        const schemeOptions = await getSipSchemes({
          category,
          acno: "0",
          fundCode: payload.fund,
        })(dispatch);

        setSchemes(schemeOptions);

        const selectedScheme = schemeOptions.find((schemeDetails) =>
          [
            schemeDetails.scheme === scheme,
            schemeDetails.plan === plan,
            schemeDetails.option === option,
          ].every(Boolean)
        );
        const requestBody = {
          Fund: payload.fund,
          TrType: "SIP",
          Frequency: sipFrequency,
          Scheme: selectedScheme.scheme,
        };
        const minResponse = await getMinimumAmount(requestBody)(dispatch);
        const sipMinAmount = minResponse.DtData[0].minamt;

        setInitialValues((prev) => ({
          ...prev,
          endDate: epochToDate(sipEndDateEpoch, "dd/mm/yyyy"),
          frequency: getFrequencyName(sipFrequency),
          installmentAmount,
          sipDay,
          fund,
          amount,
          folio: "",
          startDate: epochToDate(sipStartDateEpoch, "dd/mm/yyyy"),
          category,
          scheme: selectedScheme?.value,
          sipMinAmount: sipMinAmount,
          newPurchaseMinAmount: selectedScheme.newPurchaseMinAmount,
          multiples: selectedScheme.multiples,
          noOfInstallments,
          combo: payload.combo,
          perpetual: perpetual,
        }));
      } catch (error) {
        handleError(error);
      }
    })();
  }, [dispatch, payload.fund]);

  return {
    options: {
      amcMasters,
      categories,
      sipDays,
      schemes,
      frequencies,
      payload,
      sipType: isSipExisting ? SIP_TYPE_OPTIONS_EXISTING : SIP_TYPE_OPTIONS_NEW,
      folios,
      modeOptions,
    },
    goToCart,
    onSubmit,
    changeHandlers: {
      handleTypeChange,
      handleFolioChange,
      handlePurchaseType: handlePurchaseTypeChange,
      handleCategoryChange,
      handleSchemeChange,
      handleFrequencyChange,
      handleSipDayChange,
      handleInstallmentChange,
      handlePerpetual,
    },
    payload,
    isSipExisting,
    isEdit,
    initialValues,
    validationSchema: validationSchema({
      email: payload.email,
      mobile: payload.mobile,
      fundOptions: fundDetails,
    }),
  };
}

export const validationSchema = ({
  email,
  mobile,
  fundOptions,
}: {
  email: string;
  mobile: string;
  fundOptions: InvestorFundDetails[];
}) =>
  Yup.object().shape({
    fund: Yup.string().required("AMC is required*"),
    sipType: Yup.string().required("SIP Type is required*"),
    category: Yup.string()
      .when("sipType", {
        is: (value: string) => [NEWP, NEW].includes(value),
        then: (schema) => schema.required("Category is required"),
        otherwise: (schema) => schema.notRequired(),
      })
      .test("category", function (value) {
        const { purchaseType } = this.parent;
        if (purchaseType === NEW && !value) {
          return this.createError({
            message: `Category is required`,
          });
        }
        return true;
      }),
    folio: Yup.string()
      .when("sipType", {
        is: (value: string) => [EXISTINGP, EXISTING].includes(value),
        then: (schema) => schema.required("Folio is required"),
        otherwise: (schema) => schema.notRequired(),
      })
      .test(
        "email",
        "Email of the selected folio does not match with email of other cart item",
        function (value) {
          const { fund } = this.parent;
          const selectedFolio = fundOptions.find(
            ({ Acno, Fund }) => Acno.toString() === value && fund === Fund
          );
          if (!selectedFolio) return true;
          const { email: folioEmail } = selectedFolio;
          return email === folioEmail;
        }
      )
      .test(
        "mobile",
        "mobile of the selected folio does not match with mobile of other cart items",
        function (value) {
          const { fund } = this.parent;
          const selectedFolio = fundOptions.find(
            ({ Acno, Fund }) => Acno.toString() === value && fund === Fund
          );
          if (!selectedFolio) return true;
          const { Mobile } = selectedFolio;
          return mobile === Mobile;
        }
      ),
    scheme: Yup.string().required("Scheme is required*"),
    frequency: Yup.string().required("Frequency is required*"),
    noOfInstallments: Yup.string()
      .required("No of Installments is required*")
      .test("minimum installments", function (value) {
        const { parent } = this;
        const { minimumInstallments } = parent;
        if (Number(value) < Number(minimumInstallments)) {
          return this.createError({
            message: `Minimum number of installments is ${minimumInstallments}`,
          });
        }
        return true;
      }),
    sipDay: Yup.string().required("Sip Day is required*"),
    startDate: Yup.string().required("Sip Start Date is required*"),
    endDate: Yup.string().required("Sip Start Date is required*"),
    perpetualSip: Yup.boolean(),
    installmentAmount: Yup.string()
      .required("Installment amount is required*")
      .test("minimum SIP amount", function (amount) {
        const { sipMinAmount = 500, multiples = 1 } = this.parent;

        if (Number(sipMinAmount) > Number(amount)) {
          return this.createError({
            message: `Minimum amount is  ${convertToInr(sipMinAmount)}`,
          });
        }
        if (Number(amount) % Number(multiples) !== 0) {
          return this.createError({
            message: `SIP Amount should be a multiple of ${multiples}`,
          });
        }

        return true;
      }),
    amount: Yup.string().when("sipType", {
      is: (value: string) => [NEWP, EXISTINGP].includes(value),
      then: Yup.string()
        .required("Lumpsum amount is required for purchase with payment*")
        .test("minimum lumpsum amount", function (amount) {
          const { newPurchaseMinAmount = 500, multiples = 1 } = this.parent;
          if (Number(newPurchaseMinAmount) > Number(amount)) {
            return this.createError({
              message: `Minimum amount is  \u20B9 ${newPurchaseMinAmount}`,
            });
          }
          if (Number(amount) % Number(multiples) !== 0) {
            return this.createError({
              message: `Amount should be a multiple of ${multiples}`,
            });
          }
          return true;
        }),
      otherwise: Yup.string().notRequired(),
    }),
  });

export interface Values {
  modeOfRegistration: "ISIP" | "" | "KOTM" | "AOTM";
  fund: string;
  sipType: string;
  scheme: string;
  folio?: string | number;
  purchaseType?: string;
  category?: string;
  frequency: string;
  noOfInstallments: string | number;
  sipDay: string | number;
  startDate: string;
  endDate: string;
  perpetual: boolean;
  installmentAmount: string | number;
  amount?: string | number;
  minimumInstallments?: string | number;
  sipMinAmount?: string | number;
  newPurchaseMinAmount?: string | number;
  multiples?: string | number;
  combo?: boolean;
}
